import { getDataBase } from '@/db';



export default class LogMovilDAL{

    /**
     * Agregar la id de plomero como inicio de sesion
     * @param {Number} lnPlomero Id de Plomero
     * @param {String} lcNombre Nombre y Apellido del Plomero
     */
    static async addLogMovil(lnPlomero, lcNombre){
        try {
          
            const db = await getDataBase();
            const tx = db.transaction('LOGMOVIL', 'readwrite');
            const store = tx.objectStore('LOGMOVIL');

            const loLog = {
                Plomero: lnPlomero,
                Nombre: lcNombre
            }

            await store.add(loLog);
            tx.done;
        } catch (error) {
            throw new Error(error);
        }
    }

    static async updateLogMovil(lnPlomero, lcNombre){
        try {
          
            const db = await getDataBase();
            const tx = db.transaction('LOGMOVIL', 'readwrite');
            const store = tx.objectStore('LOGMOVIL');
            const laResults = await store.getAll();

            if(laResults.length > 0){
                const loResult = laResults[0];
                loResult.Nombre = lcNombre;
                loResult.Plomero = lnPlomero;
                await store.put(loResult);
            }else{
                await this.addLogMovil(lnPlomero, lcNombre);
            }

            tx.done;
        } catch (error) {
            throw new Error(error);
        }
    }


    static async getAll(){
        try {
          
            const db = await getDataBase();
            const tx = db.transaction('LOGMOVIL', 'readonly');
            const store = tx.objectStore('LOGMOVIL');
            const laResult = await store.getAll();
            return laResult;
        } catch (error) {
            throw new Error(error);
        }
    } 
}